import { createThemeFromBase } from './ovivio-base.theme';
import { OvivioLogoComponent } from 'src/components/shared/ovivio-logo/ovivio-logo.component';

/**
 * Ovivio Theme Configuration
 *
 * This theme uses the new Ovivio brand identity with blue as primary (#0D8CED),
 * purple as secondary (#7F53F9), and orange as accent/warning (#FA5329).
 * Extends the base Ovivio theme with brand-specific colors and assets.
 */
export const ovivioTheme = createThemeFromBase({
  id: 'ovivio',
  name: 'Ovivio',
  brandName: 'Ovivio Activities',

  domains: [
    'ovivio-activities-admin-test.web.app',
    'ovivio-activities-admin-test.firebaseapp.com',
    'activities.uk.ovivio.com',
    'activities.ovivio.nl',
    'ovivio.nl',
  ],

  colors: {
    primary: {
      main: '#7F53F9',
      light: '#F2E6FE',
      medium: '#CEB5FC',
      dark: '#5D3DB7',
      contrast: '#ffffff',
    },

    secondary: {
      main: '#0D8CED',
      light: '#E5F2FF',
      medium: '#B3DDFF',
      dark: '#0A6AB8',
      contrast: '#ffffff',
    },

    warn: {
      main: '#FA5329',
      light: '#FBF3EF',
      medium: '#FDC8B4',
      dark: '#C8421F',
      contrast: '#ffffff',
    },

    warning: '#FA5329',
    purple: '#7F53F9',

    alert: '#FA5329',
    alertLight: '#FDC8B4',

    bso: '#7F53F9',
    kdv: '#0D8CED',
  },

  fonts: {},
  ui: {},

  assets: {
    logo: './assets/images/logo-ovivio.png',
    favicon: 'assets/favicons/favicon-ovivio.ico',
    logoComponent: OvivioLogoComponent,
    logoTitle: 'Activities',
    poweredByLogo: '',
    sidebarBackground: 'none',
    avatarBackground: './assets/images/ovivio-avatar-bg.png',
    avatarImg: './assets/images/avatar-ovivio.svg',
    activityPlaceholder: './assets/images/activities/activity-placeholder.png',
    activityBlockedImage: './assets/images/activities/activity-blocked.png',
    activity404Image: './assets/images/activities/activity-404.jpg',
  },

  icons: {
    activities: 'ovivio-notebook',           // Notebook for activities
    baseActivities: 'ovivio-notebook',       // Notebook for base activities
    examples: 'ovivio-book-open',            // Open book for examples/learning experiences
    baseExamples: 'ovivio-book-open',        // Open book for base examples
    calendar: 'ovivio-calendar',             // Calendar icon
    pinboard: 'ovivio-push-pin',             // Push pin for pinboard
    organizationUsers: 'ovivio-user-square', // User square for organization users
    organizationDetails: 'ovivio-building',  // Building for organization details
    settings: 'ovivio-gear',                 // Gear for settings
    activeUsers: 'ovivio-user-check',        // User with check for active users
    insights: 'ovivio-footprints',           // Footprints for insights/analytics
    newsItems: 'ovivio-newspaper',           // Newspaper for news items
    baseNewsItems: 'ovivio-newspaper',       // Newspaper for base news items
    reviews: 'ovivio-sidebar',               // Sidebar/reviews icon
  },

  auth0: {
    logoUrl: './assets/images/logo-ovivio.png',
    themeColor: '#7F53F9',
  },
});
